"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.limitTwoDecimals = limitTwoDecimals;
exports.limitInteger = limitInteger;
exports.linkJudgeBegin = exports.isAllNum = exports.isNone = exports.urlIsLITB = exports.isExcelFile = exports.isLitbSystem = exports.isHasBlank = exports.isEn = exports.isAllLetters = exports.isAndroid = exports.isIOS = exports.isMoblieClient = void 0;

var _regex = require("./regex");

// 公用正则判断方法
var isMoblieClient = function isMoblieClient(userAgent) {
  var _userAgent$match;

  var userAgentMobileReg = new RegExp(_regex.userAgentMobileRegExp);
  return userAgent === null || userAgent === void 0 ? void 0 : (_userAgent$match = userAgent.match) === null || _userAgent$match === void 0 ? void 0 : _userAgent$match.call(userAgent, userAgentMobileReg);
};

exports.isMoblieClient = isMoblieClient;

var isIOS = function isIOS(userAgent) {
  var _userAgent$match2;

  var iosReg = new RegExp(_regex.iosRegExp);
  return !!(userAgent === null || userAgent === void 0 ? void 0 : (_userAgent$match2 = userAgent.match) === null || _userAgent$match2 === void 0 ? void 0 : _userAgent$match2.call(userAgent, iosReg));
};

exports.isIOS = isIOS;

var isAndroid = function isAndroid(userAgent) {
  var _userAgent$match3;

  var androidReg = new RegExp(_regex.androidRegExp);
  return !!(userAgent === null || userAgent === void 0 ? void 0 : (_userAgent$match3 = userAgent.match) === null || _userAgent$match3 === void 0 ? void 0 : _userAgent$match3.call(userAgent, androidReg));
};

exports.isAndroid = isAndroid;

var isAllLetters = function isAllLetters(value) {
  var allLettersReg = new RegExp(_regex.allLettersRegExp);
  return allLettersReg.test(value);
};

exports.isAllLetters = isAllLetters;

var isEn = function isEn(value) {
  var enReg = new RegExp(_regex.enRegExp);
  return enReg.test(value);
};

exports.isEn = isEn;

var isHasBlank = function isHasBlank(value) {
  var hasBlankReg = new RegExp(_regex.hasBlankRegExp);
  return hasBlankReg.test(value);
};

exports.isHasBlank = isHasBlank;

var isLitbSystem = function isLitbSystem(value) {
  var litbSystemReg = new RegExp(_regex.litbSystemRegExp);
  return litbSystemReg.test(value);
};

exports.isLitbSystem = isLitbSystem;

var isExcelFile = function isExcelFile(fileName) {
  var excelTypeReg = new RegExp(_regex.excelTypeRegExp);
  return excelTypeReg.test(fileName);
};

exports.isExcelFile = isExcelFile;

function limitTwoDecimals(value) {
  // 正则， 限制两位小数， 不是数字或超过两位小数显示空字符串, 不能输入负号
  // eg. 输入 12，345  输出 12.34； 输入s ，输出"”
  var reg = /^(\d+)\.(\d\d).*$/;
  var reg2 = /^(\-)*(\d+)\.(\d\d).*$/;

  if (value) {
    value = value.toString();
    return !isNaN(Number(value)) ? !reg.test(value) && reg2.test(value) ? Math.abs(value) : value.replace(reg, "$1.$2") : "";
  }

  return "";
}

function limitInteger(value) {
  // 正则， 正整数
  var reg = /\D/g;

  if (value) {
    value = value.toString();
    return !isNaN(Number(value)) ? value.replace(reg, "") : "";
  }

  return "";
}

var urlIsLITB = function urlIsLITB(host) {
  return /lightinthebox/gi.test(host);
};

exports.urlIsLITB = urlIsLITB;

var isNone = function isNone(value) {
  var noneReg = new RegExp(_regex.noneRegExp);
  return noneReg.test(value);
};

exports.isNone = isNone;

var isAllNum = function isAllNum(value) {
  var numReg = new RegExp(_regex.numRegExp);
  return numReg.test(value);
};

exports.isAllNum = isAllNum;

var linkJudgeBegin = function linkJudgeBegin(TrimPath, domain, protocol) {
  if (/^(https?|\/\/)/i.test(TrimPath)) {
    return TrimPath;
  }

  if (/^(https)/i.test(domain)) {
    return "".concat(domain).concat(TrimPath);
  }

  return "".concat(protocol, "//").concat(domain).concat(TrimPath);
};

exports.linkJudgeBegin = linkJudgeBegin;